export default __webpack_public_path__ + "static/char-s-08-jp-51a38cfd31e39bcece28972882a55667.webp";